import './SelectAdvancement.css';

function SelectAdvancement({ onSelectAdvancement, onRemoveAdvancements, options, removeCost, currentAP, uv }) {
  return (
    <div className='dialogbackground' onClick={() => onSelectAdvancement(null, uv)}>
      <div className='advancementdialog'>
        {
          options.map(opt => 
            opt.cost <= currentAP ?
              <div key={opt.id} className='advancement' onClick={e => { e.stopPropagation(); onSelectAdvancement(opt.id, uv); }}>
                <span className='cost'>Cost: {opt.level} AP</span>
                <img alt="" src={require(`./images/${opt.id}.svg`).default}></img>
                {opt.name}
              </div>
            :
              <div key={opt.id} className='advancement unaffordable' onClick={e => { e.stopPropagation(); }}>
                <span className='cost'>Cost: {opt.level} AP</span>
                <img alt="" src={require(`./images/${opt.id}.svg`).default}></img>
                {opt.name}
             </div>
          )
        }
        {
          !!removeCost &&
            (removeCost <= currentAP ?
              <div key='remove' className='advancement' onClick={e => { e.stopPropagation(); onRemoveAdvancements(removeCost, uv); }}>
                <span className='cost'>Cost: {removeCost} AP</span>
                <img alt="" src={require(`./images/remove.svg`).default}></img>
                Remove advancements
              </div>
            :
              <div key='remove' className='advancement unaffordable' onClick={e => { e.stopPropagation(); }}>
                <span className='cost'>Cost: {removeCost} AP</span>
                <img alt="" src={require(`./images/remove.svg`).default}></img>
                Remove advancements
              </div>)
        }
      </div>
    </div>
  );
}

export default SelectAdvancement;
